export const Q_PARKING_REF_ID = "parking-ref-id"
export const PARKING_FINDER_QUERY_KEY = [
  "parking-finder",
  "active-record",
] as const
